<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-cascades"></i> 景点管理
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
                <!--<el-button
                  type="primary"
                  icon="el-icon-delete"
                  class="handle-del mr10"
                  @click="delAllSelection"
                >批量删除
                </el-button>-->
                <el-select class="handle-select mr10 wd200" clearable placeholder="景点目录" v-model="search.menu">
                    <el-option :key="item.Id"
                               :label="'【'+item.cityName+'】-'+item.Sname"
                               :value="item.Id"
                               v-for="item in sceOpt.area"></el-option>
                </el-select>
                <el-input class="handle-input mr10" clearable placeholder="景区名称" v-model="search.keyword" clearable></el-input>
                <el-button @click="handleSearch" icon="el-icon-search" type="primary">搜索</el-button>
                <el-button @click="getScenicData" icon="el-icon-refresh" type="warning">刷新</el-button>
                <el-button @click="updateSceMenu" icon="el-icon-refresh-right" type="success">更新类目说明</el-button>
            </div>
            <el-table
                    :data="tableData"
                    @selection-change="handleSelectionChange"
                    border
                    class="table"
                    header-cell-class-name="table-header"
                    ref="multipleTable"
            >
                <el-table-column align="center" label="ID" prop="Id" sortable width="65"></el-table-column>
                <el-table-column label="景区名称" prop="Sname" sortable></el-table-column>
                <el-table-column label="所属区域" prop="scenicName" sortable></el-table-column>
                <el-table-column label="景区地址" prop="Sadd"></el-table-column>
                <el-table-column align="center" label="排序编号" prop="Ssorder"></el-table-column>
                <el-table-column :filter-method="filterTag"
                                 :filters="[{ text: '屏蔽中', value: '0' }, { text: '已下线', value: '1' }, { text: '正常展示', value: '2' }]"
                                 align="center"
                                 label="景区状态"
                                 prop="Sstate">
                    <template slot-scope="scope">
                        <el-tag
                                :type="scope.row.Sstate===0?'warning ':(scope.row.Sstate===1?'danger':(scope.row.Sstate===2?'success':'warning'))"
                        >
                            {{scope.row.Sstate===0?'屏蔽中':(scope.row.Sstate===1?'已下线':(scope.row.Sstate===2?'正常展示':'其他状态'))}}
                        </el-tag>
                    </template>
                </el-table-column>

                <!--      <el-table-column sortable label="景点等级" align="center">
                        <template slot-scope="scope">
                          <el-tag>
                            {{scope.row.Sstar===0?'暂未评级':(scope.row.Sstar===1?'A':(scope.row.t===2?'AA':(scope.row.Sstar===3?'AAA':(scope.row.Sstar===4?'AAAA':'AAAAA'))))}}
                          </el-tag>
                        </template>
                      </el-table-column>-->
                <el-table-column align="center" label="景区政策" width="270">
                    <template slot-scope="scope">
                        <el-button
                                @click="updatePic(scope.$index, scope.row)"
                                icon="el-icon-picture-outline"
                                type="text"
                        >门市政策
                        </el-button>
                        <el-button
                                @click="updatePolicy(scope.$index, scope.row)"
                                icon="el-icon-s-ticket"
                                type="text"
                        >同业政策
                        </el-button>
                        <el-button
                                @click="updateContacts(scope.$index, scope.row)"
                                icon="el-icon-s-cooperation"
                                type="text"
                        >联系人信息
                        </el-button>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="操作" width="180">
                    <template slot-scope="scope">
                        <el-button
                                @click="handleEdit(scope.$index, scope.row)"
                                icon="el-icon-edit"
                                type="text"
                        >编辑
                        </el-button>
                        <el-button
                                @click="getTickets(scope.$index, scope.row)"
                                icon="el-icon-picture-outline"
                                type="text"
                        >拥有门票
                        </el-button>
                        <!--<el-button
                            type="text"
                            icon="el-icon-delete"
                            class="red"
                            @click="handleDelete(scope.$index, scope.row)"
                        >删除</el-button>-->
                    </template>
                </el-table-column>
            </el-table>
            <div class="searchPage" v-show="show.search">
                共计 【 {{pageTotal}} 】条符合条件的结果
            </div>

            <div class="pagination" v-show="show.page">
                <el-pagination
                        :current-page="query.pageIndex"
                        :page-size="query.pageSize"
                        :total="pageTotal"
                        @current-change="handlePageChange"
                        background
                        layout="total, prev, pager, next"
                ></el-pagination>
            </div>
        </div>

        <!-- 弹出框@编辑景点信息 -->
        <el-dialog :visible.sync="editVisible" title="编辑景点信息" width="50%">
            <el-form :model="form" label-width="70px" ref="form">
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item label="景点名称">
                            <el-input clearable v-model="form.Sname"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="展示状态">
                            <el-select placeholder="请选择" v-model="form.Sstate">
                                <el-option :key="item.value"
                                           :label="item.label"
                                           :value="item.value"
                                           v-for="item in sceOpt.state"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="景区标签">
                            <el-select
                                    v-model="scenicTags"
                                    multiple
                                    filterable
                                    default-first-option
                                    placeholder="请选择标签属性">
                                <el-option
                                        v-for="item in tags"
                                        :key="item.Id"
                                        :label="item.Tname"
                                        :value="item.Id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item label="景点拼音">
                            <el-input clearable v-model="form.Schinese"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="所属区域">
                            <el-select placeholder="请选择" v-model="form.Spid">
                                <el-option :key="item.Id"
                                           :label="item.Sname"
                                           :value="item.Id"
                                           v-for="item in sceOpt.area"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="营业时间">
                            <el-input clearable v-model="form.Sopentime"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20">
                    <el-col :span="16">景点首图  &nbsp;&nbsp;&nbsp;&nbsp;<el-link  @click="openImg('http://yp.img.lvyoujisan.com/scenic_logo/'+form.city+'/'+form.Slogo)">http://yp.img.lvyoujisan.com/scenic_logo/{{form.city}}/{{form.Slogo}}</el-link>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="更新图片">
                            <el-upload
                                    :before-remove="beforeRemove"
                                    :before-upload="beforeAvatarUpload"
                                    :http-request="uploadScenicLogo"
                                    action=""
                                    :show-file-list="false"
                                    list-type="picture">
                                <i class="el-icon-refresh-right"></i>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item label="景点星级">
                            <el-select placeholder="请选择" v-model="form.Sstar">
                                <el-option :key="item.value"
                                           :label="item.label"
                                           :value="item.value"
                                           v-for="item in sceOpt.star"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="景点排序">
                            <el-input clearable v-model="form.Ssorder"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="是否免费">
                            <el-radio-group v-model="form.Sfree">
                                <el-radio :label="1">收费景点</el-radio>
                                <el-radio :label="0">免费景点</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item label="携程ID">
                            <el-input clearable v-model="form.ctrip"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="美团ID">
                            <el-input clearable v-model="form.meituan"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="去哪儿ID">
                            <el-input clearable v-model="form.qunar"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item label="景点介绍">
                    <el-input
                            maxlength="5000"
                            placeholder="请输入内容"
                            rows="10"
                            show-word-limit
                            type="textarea"
                            v-model="form.Sdescription"
                    ></el-input>
                </el-form-item>
                <el-form-item label="资源对接">
                    <el-input clearable v-model="form.Ssupplier"></el-input>
                </el-form-item>

                <el-form-item label="内部政策">
                    <el-input
                            maxlength="500"
                            placeholder="请输入内容"
                            rows="10"
                            show-word-limit
                            type="textarea"
                            v-model="form.Spolicy"
                    >
                    </el-input>
                </el-form-item>

                <el-form-item label="政策图片">
                    <el-upload
                            :before-remove="beforeRemove"
                            :before-upload="beforeAvatarUpload"
                            :file-list="fileList"
                            :http-request="upload"
                            :limit="10"
                            :on-exceed="handleExceed"
                            :on-preview="handlePictureCardPreview"
                            :on-remove="handleRemove"
                            action=""
                            list-type="picture">
                        <i class="el-icon-plus"></i>
                    </el-upload>
                </el-form-item>

                <!--        <el-form-item label="交通信息">
                            <el-input clearable v-model="form.Straffic"></el-input>
                        </el-form-item>


                        <el-form-item label="景点引言">
                            <el-input clearable v-model="form.Sslogan"></el-input>
                        </el-form-item>-->


            </el-form>
            <span class="dialog-footer" slot="footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button @click="saveEdit" type="primary">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 弹出框@展示该景点所拥有门票信息 -->
        <el-dialog :visible.sync="ticketVisible" title="景点所属门票信息" width="80%">
            <template>
                <el-table
                        :data="ticketData"
                        style="width: 100%">
                    <el-table-column
                            label="门票ID"
                            prop="id"
                            width="180">
                    </el-table-column>
                    <el-table-column
                            label="门票名称"
                            prop="tname"
                            width="180">
                    </el-table-column>
                    <el-table-column
                            label="散客价格"
                            prop="tprice_peer"
                            width="180">
                    </el-table-column>
                    <el-table-column
                            label="团队价格"
                            prop="tprice_team">
                    </el-table-column>
                    <el-table-column
                            label="门票状态"
                            prop="tstate">
                        <template slot-scope="scope">
                            <el-tag
                                    :type="scope.row.tstate===0?'warning ':(scope.row.tstate===1?'success':(scope.row.tstate===2?'danger':(scope.row.tstate===3?'info':'warning')))"
                            >
                                {{scope.row.tstate===0?'屏蔽中':(scope.row.tstate===1?'显示中':(scope.row.tstate===2?'可售':(scope.row.tstate===3?'在售':'正推荐')))}}
                            </el-tag>
                        </template>

                    </el-table-column>
                    <el-table-column
                            label="门票说明"
                            prop="tnote_external">
                    </el-table-column>
                </el-table>
            </template>

        </el-dialog>

        <!-- 弹出框@编辑图片信息 -->
        <el-dialog :visible.sync="pictureVisible" title="管理景点公共信息图片" width="50%">

            <el-upload
                    :before-remove="beforeRemove"
                    :before-upload="beforeAvatarUpload"
                    :file-list="fileList"
                    :http-request="upload"
                    :limit="10"
                    :on-exceed="handleExceed"
                    :on-preview="handlePictureCardPreview"
                    :on-remove="handleRemove"
                    action=""
                    list-type="picture">
                <i class="el-icon-plus">添加上传图片</i>
            </el-upload>
            <i @click="updateFileOrder(1)" class="el-icon-s-operation" style="margin-top: 20px;"> 图片展示排序</i>
        </el-dialog>
        <el-dialog :visible.sync="picture_Visible" title="图片详情展示" width="80%">
            <img :src="picture_ImageUrl" alt="" width="100%">
        </el-dialog>

        <!-- 弹出框@编辑景点同业政策 -->
        <el-dialog :visible.sync="policyVisible" title="管理景点同业政策文件片" width="80%">
            <el-upload
                    :before-remove="beforeRemove"
                    :before-upload="beforeAvatarUpload"
                    :file-list="fileList"
                    :http-request="upload"
                    :limit="10"
                    :on-exceed="handleExceed"
                    :on-preview="handlePictureCardPreview"
                    :on-remove="handleRemove"
                    action=""
                    list-type="picture">
                <i class="el-icon-plus"></i>
            </el-upload>


        </el-dialog>
        <!--<el-dialog :visible.sync="policy_Visible" title="政策文件详情展示" width="80%">
            <img :src="policy_ImageUrl" alt="" width="100%">
        </el-dialog>-->

        <!-- 弹出框@编辑景点联系人信息 -->
        <el-dialog :visible.sync="contactsVisible" title="管理景点联系人信息" width="80%">
            <el-form :model="form" label-width="70px" ref="form">

                <el-row :gutter="24" v-for="(person, index) in contactsList" :key="index">
                    <el-col :span="5">
                        <el-form-item label="职位类型">
                            <el-select placeholder="请选择" v-model="person.Crole">
                                <el-option :key="item.value"
                                           :label="item.label"
                                           :value="item.value"
                                           v-for="item in contactType"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="姓名">
                            <el-input clearable v-model="person.Cname"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5">
                        <el-form-item label="电话号码">
                            <el-input clearable v-model="person.Cphone"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="备注说明">
                            <el-input clearable v-model="person.Cmemo"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="2">
                        <el-button type="primary" @click="updateContact(person)">保存</el-button>
                    </el-col>
                </el-row>
                <el-button @click="addContacts">+新增联系人</el-button>
            </el-form>

        </el-dialog>

        <!-- 弹出框@对景点拥有的图片/文件展示排序 -->
        <el-dialog :visible.sync="orderVisible" title="景点所属图片/文件信息" width="80%">
            <template>
                <el-table
                        :data="orderData"
                        style="width: 100%">

                    <el-table-column
                            label="文件ID"
                            prop="id"
                            width="80">
                    </el-table-column>
                    <el-table-column
                            label="查看图片"
                            width="80">
                        <template slot-scope="scope">
                            <el-link type="primary" @click="openImg(scope.row.url)">查看图片</el-link>
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="文件名称">
                        <template slot-scope="scope">
                            <el-input class="wd400 mr10" v-model="scope.row.name" placeholder="图片描述"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="更新时间"
                            prop="time"
                            width="180">
                    </el-table-column>

                    <el-table-column
                            label="排序编号"
                            show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-input class="wd100 mr10" v-model="scope.row.order" placeholder="排序编号"></el-input>

                            <el-button @click="saveImgOrder(scope.row.order,scope.row.name,scope.row.id)"
                                       type="primary">确 定
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </template>

        </el-dialog>

    </div>
</template>

<script>
    export default {
        name: 'basetable',
        data() {
            return {
                scenicTags: [],
                tags: [],
                contactType: [{
                    value: 0,
                    label: '前台-客服'
                }, {
                    value: 1,
                    label: '销售-营销'
                }, {
                    value: 2,
                    label: '三方-渠道'
                }],
                contactsList: [],
                orderVisible: false,
                orderData: [],
                Iorder: '',

                contactsVisible: false,
                contacts_Visible: false,

                policyVisible: false,

                pictureVisible: false,
                picture_ImageUrl: '',
                picture_Visible: false,
                sceOpt: {
                    area: [],
                    star: [{
                        value: 1,
                        label: 'A'
                    }, {
                        value: 2,
                        label: 'AA'
                    }, {
                        value: 3,
                        label: 'AAA'
                    }, {
                        value: 4,
                        label: 'AAAA'
                    }, {
                        value: 5,
                        label: 'AAAAA'
                    }, {
                        value: 0,
                        label: '暂未评级'
                    }],
                    state: [{
                        value: 0,
                        label: '屏蔽中'
                    }, {
                        value: 1,
                        label: '已下线'
                    }, {
                        value: 2,
                        label: '正常展示'
                    }, {
                        value: 3,
                        label: '其他状态'
                    }],
                    free: {}
                },
                query: {
                    sdid: sessionStorage.getItem('ml_cityId'),
                    address: '',
                    name: '',
                    pageIndex: 1,
                    pageSize: 10
                },
                search: {
                    keyword: '',
                    menu: '',
                    sdid: sessionStorage.getItem('ml_cityId')
                },
                show: {
                    page: true,
                    search: false
                },
                tableData: [],
                ticketData: [],
                multipleSelection: [],
                delList: [],
                editVisible: false,

                ticketVisible: false,
                addVisible: false,
                pageTotal: 0,
                form: {},
                idx: -1,
                id: -1,
                fileList: [],
                image_type: 1,
                cityName:'guilin',
                imgUrl:''
            };
        },
        created() {
            // this.reload();
            this.getScenicData();
        },
        methods: {
            //初始化 景点列表数据
            async getScenicData() {
                const { data: res } = await this.$http.post('admin/scenics/initScenicData', {
                    query: this.query
                });
                if (res.code !== 200) {
                    return this.$message.error('系统错误，获取景点数据失败，请联系管理员!');
                }
                this.sceOpt.area = res.area;
                this.tags = res.tags;
                this.tableData = res.list;
                this.pageTotal = res.pageTotal || 10;
                this.search.keyword = '';
                this.search.menu = '';
                this.show.page = true;
                this.show.search = false;
                this.$message.success('【景点数据】加载成功!');
            },

            //修改景点类目数据
            async updateSceMenu() {
                const { data: res } = await this.$http.post('admin/scenics/updateSenicMenu', {
                    query: this.query
                });
                if (res.code !== 200) {
                    return this.$message.error('系统错误，获取景点数据失败，请联系管理员!');
                }
                this.$message.success('【景点类目数据】更新成功!');
            },

            // 触发搜索按钮
            async handleSearch() {
                const { data: res } = await this.$http.post('admin/scenics/searchScenic', {
                    search: this.search
                });

                if (res.code !== 200) {
                    return this.$message.error('系统错误，获取景点数据失败，请联系管理员!');
                }
                this.sceOpt.area = res.area;
                this.tags = res.tags;
                this.tableData = res.list;
                this.pageTotal = res.pageTotal;
                this.show.page = false;
                this.show.search = true;
                this.$message.success('搜索成功，共有【 ' + res.pageTotal + ' 】符合条件的结果');
            },

            // 删除操作
            handleDelete(index, row) {
                // 二次确认删除
                this.$confirm('确定要删除吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        this.$message.success('删除成功');
                        this.tableData.splice(index, 1);
                    })
                    .catch(() => {
                    });
            },

            // 多选操作
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },

            // 批量删除
            delAllSelection() {
                const length = this.multipleSelection.length;
                let str = '';
                this.delList = this.delList.concat(this.multipleSelection);
                for (let i = 0; i < length; i++) {
                    str += this.multipleSelection[i].name + ' ';
                }
                this.$message.error(`删除了${str}`);
                this.multipleSelection = [];
            },

            // 编辑景点信息操作
            async handleEdit(index, row) {
                this.idx = index;
                this.form = row;
                this.editVisible = true;
                const { data: protags } = await this.$http.post('/admin/scenics/getTags', {
                    pid: this.form.Id,
                    type: '1'
                });
                this.scenicTags = protags;
                //获取景点内部结算政策图片
                const { data: res } = await this.$http.post('/admin/scenics/getImages', {
                    pid: this.form.Id,
                    type: '3'
                });
                this.image_type = '3';
                this.fileList = res;
                this.cityName=row.city;
                this.imgUrl='https://yp.img.lvyoujisan.com/'+row.Slogo;
            },

            // 查看景点拥有门票
            async getTickets(index, row) {
                this.idx = index;
                this.form = row;
                this.ticketVisible = true;
                const { data: res } = await this.$http.post('/admin/scenics/getTickets', {
                    pid: this.form.Id,
                    type: '1'
                });
                this.ticketData = res;
            },

            // 景点门市政策图片顺序调整 - 展示弹窗
            async updateFileOrder(type) {
                this.orderVisible = true;
                const { data: res } = await this.$http.post('/admin/scenics/getImages', {
                    pid: this.form.Id,
                    type: type
                });
                this.orderData = res;
                this.pictureVisible = false;
                this.policyVisible = false;
            },

            // 景点门市政策图片展示顺序修改-保存
            async saveImgOrder(order, name, id) {
                const { data: res } = await this.$http.post('/admin/scenics/updateImagesOrder', {
                    order: order,
                    id: id,
                    name: name
                });
            },

            // 打开网址对应的图片
            openImg(url) {
                window.open(url, '_blank');

            },

            // 景点门市政策图片修改-展示弹出
            async updatePic(index, row) {
                this.idx = index;
                this.form = row;
                this.pictureVisible = true;
                const { data: res } = await this.$http.post('/admin/scenics/getImages', {
                    pid: this.form.Id,
                    type: '1'
                });
                this.image_type = '1';
                this.fileList = res;
                this.cityName=row.city;
            },

            // 景点门同业市政策文件-展示弹窗
            async updatePolicy(index, row) {
                this.idx = index;
                this.form = row;
                this.policyVisible = true;
                const { data: res } = await this.$http.post('/admin/scenics/getImages', {
                    pid: this.form.Id,
                    type: '2'
                });
                this.image_type = '2';
                this.fileList = res;
            },
            // 景点门同业联系人信息更新
            async updateContacts(index, row) {
                this.idx = index;
                this.form = row;
                this.contactsVisible = true;
                const { data: res } = await this.$http.post('/admin/contacts/showContacts', {
                    pid: this.form.Id,
                    type: 1
                });
                this.contactsList = res.list;
            },

            //修改保存 联系人信息
            async updateContact(person) {
                const { data: res } = await this.$http.post('admin/contacts/updateContacts', {
                    Id: person.Id,
                    Cname: person.Cname,
                    Cphone: person.Cphone,
                    Cmemo: person.Cmemo,
                    Crole: person.Crole
                });
                if (res.code !== 200) {
                    return this.$message.error('系统错误，修改联系人失败，请联系管理员!');
                } else {
                    this.$message.success('【联系人数据】更新成功!');
                }
            },
            //新增联系人信息
            async addContacts() {
                const { data: res } = await this.$http.post('admin/contacts/addContacts', {
                    Cpid: this.form.Id,
                    Cstate: 1,
                    Crole: 1,
                    Ctype: 1
                });
                if (res.code !== 200) {
                    return this.$message.error('系统错误，未能添加联系人，请联系管理员!');
                } else {
                    this.$message.success('【联系人数据】更新成功!');
                    const { data: res } = await this.$http.post('/admin/contacts/showContacts', {
                        pid: this.form.Id,
                        type: 1
                    });
                    this.contactsList = res.list;
                }
            },

            // 保存编辑
            async saveEdit() {
                this.editVisible = false;
                this.$set(this.tableData, this.idx, this.form);
                const { data: res } = await this.$http.post('/admin/scenics/addScenic', {
                    form: this.form,
                    tags: this.scenicTags
                });
                if (res.code !== 200) {
                    this.addVisible = false;
                    return this.$message.error('系统错误，修改数据失败，请联系管理员!');
                }
                this.$message.success(res.message);
                this.addVisible = false;
                //  this.form=[];
            },
            // 分页导航
            handlePageChange(val) {
                this.$set(this.query, 'pageIndex', val);
                this.getScenicData();
            },
            //标签筛选
            filterTag(value, row) {
                return row.Sstate == value;
            },

            //上传文件
            async uploadScenicLogo(param) {
                const formData = new FormData();
                formData.append('file', param.file);
                formData.append('sid', this.form.Id);
                formData.append('city', this.cityName);
                const { data: res } = await this.$http.post('/admin/scenics/updateScenicLogo', formData);
                if (res.code !== 200) {
                    return this.$message.error('系统错误，获取景点数据失败，请联系管理员!');
                }
                this.imgUrl='http://yp.img.lvyoujisan.com/'+res.url;
                this.form.Slogo=res.url;
                this.$message.success('【景点Logo图片】更新成功!');
            },

            //上传文件
            async upload(param) {
                const formData = new FormData();
                formData.append('file', param.file);
                formData.append('pid', this.form.Id);
                formData.append('city', this.cityName);
                formData.append('image_type', this.image_type);
                const { data: res } = await this.$http.post('/admin/scenics/upload_img', formData);
                if (res.code !== 200) {
                    return this.$message.error('系统错误，获取景点数据失败，请联系管理员!');
                }
                this.$message.success('【景点图片/文件】上传成功!');
            },

            //上传前的检查判断
            beforeAvatarUpload(file) {
                const isJPG =
                    file.type === 'image/gif' ||
                    file.type === 'image/jpg' ||
                    file.type === 'image/jpeg' ||
                    file.type === 'image/png';
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isJPG) {
                    this.$message.error('仅支持gif,jpg,png格式的图片！');
                }
                if (!isLt2M) {
                    this.$message.error('上传图片大小不能超过 2MB!' + isLt2M);
                }
                return isJPG && isLt2M;
            },
            // 删除当前图片前的确认
            beforeRemove(file, fileList) {
                return this.$confirm(`确定移除 ${file.name}？`);
            },
            // 删除当前图片
            async handleRemove(file, fileList) {
                const { data: res } = await this.$http.post('/admin/scenics/updateImages', {
                    id: file.id
                });
            },
            handlePictureCardPreview(file) {
                this.picture_ImageUrl = file.url;
                this.picture_Visible = true;
            },

            //限制上传文件的数量
            handleExceed(files, fileList) {
                this.$message.warning(`当前限制选择 6 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
            }
        }
    };
</script>

<style scoped>

    .searchPage {
        font-size: 14px;
        color: #606266;
        padding: 20px 0px;
    }

    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 200px;
        display: inline-block;
    }

    .table {
        width: 100%;
        font-size: 14px;
    }

    .red {
        color: #ff0000;
    }

    .mr10 {
        margin-right: 10px;
    }

    .wd100 {
        width: 90px;
    }

    .wd400 {
        width: 400px;
    }

    .wd200 {
        width: 200px;
    }

    .table-td-thumb {
        display: block;
        margin: auto;
        width: 40px;
        height: 40px;
    }
</style>
